import React from 'react'

import { CircleHelp } from 'lucide-react'
import { Portal } from "@radix-ui/react-portal";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
	TooltipProvider
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton';

interface StatsCardProps {
	title: string
	value: any
	description?: string
	icon?: React.ReactNode
	tooltip?: string
	className?: string
	valueStyleOverride?: string
	isLoading?: boolean;
}

export function StatsCard({
	title,
	value,
	description,
	icon,
	className,
	tooltip,
	valueStyleOverride,
	isLoading = false
}: StatsCardProps) {
	return (
		<Card className={cn(
			'bg-[#0C0F1D]/70 backdrop-blur-md text-black border-2 border-black rounded-sm shadow-[4px_4px_0_0_black] p-2',
			'transition-colors duration-150',
			className
		)}>
			<CardHeader className="p-0 mb-2">
				<div className='flex flex-row items-center justify-between'>
					<div className="flex items-center gap-2">
						{icon && (
							<div className="p-1 text-white">
								{icon}
							</div>
						)}
						<CardTitle className="text-sm font-bold text-white">{title}</CardTitle>
					</div>
					{tooltip && (
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger>
									<CircleHelp className='h-4 w-4' />
								</TooltipTrigger>
								<Portal>
									<TooltipContent className='bg-black text-white border border-black'>
										{tooltip}
									</TooltipContent>
								</Portal>
							</Tooltip>
						</TooltipProvider>
					)}
				</div>
				{description && (
					<div className='pl-1'>
						<p className="text-xs text-white">{description}</p>
					</div>

				)}
			</CardHeader>

			<CardContent className='p-0'>
				{isLoading ?
					<Skeleton className='h-8 w-auto bg-white/20' />
					:
					<div className="text-2xl font-bold mt-2 ml-1 text-white">
						<span className={cn('block', valueStyleOverride)}>{value}</span>
					</div>
				}
			</CardContent>
		</Card>
	)
}
